import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import classNames from 'classnames';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PersonIcon from '@material-ui/icons/Person';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Grid } from '@material-ui/core';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import TextField from '@material-ui/core/TextField/index';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Loading from '../../../../../utils/Loading'
import {saveTemplateAdd} from '../../../../../services/Templates'
import Variable from '../../../../../helpers/Template/Variable'
import moment from 'moment'
import 'moment/locale/es'  
import { Button } from '@material-ui/core';
// Component styles
import styles from './styles';
import { ContactSupportOutlined } from '@material-ui/icons';
moment.locale('es')

class EditTemplate extends Component {
  constructor(props) {
    super(props);
    var imgData=this.props.row[1].icono.replace(/ /g, "")
    var img ="data:image/png;base64,"+imgData
    //console.log(props.row)
    this.state = {
      data:this.props.row[1],
      sucess:false,
      isLoad:false,
      id:this.props.row[1].id,
      file:img,
      img:""
    }
  }

  handleFieldChange = (field, value) => {
    const {data, id}=this.state
    if(field=="name"){
      this.setState({
        defaultJson:""
      });
    }
    if(field=="upload"){
      if (value.length > 0) {
        const file = URL.createObjectURL(value[0]);
        //console.log('file', value)
        this.setState({
          file:file,
          data:data,
          img:value
        });
      }
    }
    data[field]=value
    this.setState(data)
  };

  save =()=>{
    const {data, id, file, img}=this.state
    var user=sessionStorage.getItem("user")
    var token=sessionStorage.getItem("key")
    var reader = new FileReader();
    var dataImg=""
    if(img!==""){
      var reader = new FileReader();
      reader.readAsDataURL(img[0]);
      //console.log('img', reader.result)
      reader.onload =()=> {
        //console.log(reader.result)//string b64 data:image/png;base64,iVBOR
        var dataImg=reader.result.replace("data:image/png;base64,", '')
        //console.log(`/reporte/general/Template/?user=${user}&name=${data.nombre}&token=${token}&desc=${data.descripcion}&upload=${dataImg}&code=${data.contenido}&method=${'edit'}&args=${''}`)
        saveTemplateAdd(user, token,data.nombre, data.descripcion, dataImg, data.contenido, 'edit', id).then( value =>{
          if(value==="success"){
            this.setState({
              indexError: false,
              loadError:false,
              isLoad:false,
              sucess:true
            });
            setTimeout(() => {this.props.handleTemplate()},2000)
          }else{
            this.setState({
              indexError: 5,
              loadError:true,
              isLoad:false,
              sucess:false
            });
          }
        })
      }
    }else{
      var dataImg=file.replace("data:image/png;base64,", '')
      //console.log(`/reporte/general/Template/?user=${user}&name=${data.nombre}&token=${token}&desc=${data.descripcion}&upload=${dataImg}&code=${data.contenido}&method=${'edit'}&args=${''}`)
      saveTemplateAdd(user, token,data.nombre, data.descripcion, dataImg, data.contenido, 'edit', id).then( value =>{
        if(value==="success"){
          //console.log('call api')
          this.setState({
            indexError: false,
            loadError:false,
            isLoad:false,
            sucess:true
          });
          setTimeout(() => {this.props.handleTemplate()},2000)
        }else{
          this.setState({
            indexError: 5,
            loadError:true,
            isLoad:false,
            sucess:false
          });
        }
      })
    }
    //console.log('save')
    this.setState({
      isLoad:true,
    })
  }

  close=()=>{
    setTimeout(() => {this.props.handleTemplate()},200)
  }
  
  render() {
    const { classes  } = this.props;
    const {data, isLoad, sucess, file}=this.state
    //console.log('load',isLoad,'success', sucess)
    return (
      <PortletContent className={classes.content}>
        <Grid
          container
          spacing={1}
          className={classes.sizeTemplate}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            xl={12}
            className={[classes.orange, classes.alignCenter]}
          >
            <Typography className={[classes.buttonSave, classes.size18]}>Modificar Template</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={8}
            xl={8}
            className={[classes.top5,classes.alignCenter]}
          >
            <TextField
              className={[classes.contentWidth, classes.labelFont]}
              label="Nombre"
              name="name"
              type="text"
              defaultValue={data.nombre}
              required
              onChange={event =>
                this.handleFieldChange('nombre', event.target.value)
              }
              variant="outlined"
              inputProps={{maxLength :40}}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            xl={4}
            className={[classes.top5,classes.alignCenter]}
          >
            <TextField
              className={[classes.contentWidth, classes.labelFont]}
              label="Fecha Creación"
              name="date2"
              type="text"
              disabled={true}
              defaultValue={(moment(data.fecha_creacion).locale('es')).format("dddd,DD MMMM YYYY, h:mm:ss a")}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={8}
            xl={8}
            className={ classes.alignCenter}
          >
            <TextField
              className={[classes.contentWidth, classes.labelFont]}
              label="Descripción"
              name="name"
              type="text"
              defaultValue={data.descripcion}
              required
              onChange={event =>
                this.handleFieldChange('descripcion', event.target.value)
              }
              variant="outlined"
              inputProps={{maxLength :40}}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            xl={4}
            className={ classes.alignCenter}
          >
            <TextField
              className={[classes.contentWidth, classes.labelFont]}
              label="Fecha Actualización"
              name="date"
              type="text"
              disabled={true}
              defaultValue={(moment(data.fecha_actualizacion).locale('es')).format("dddd,DD MMMM YYYY, h:mm:ss a")}
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            xl={6}
            className={classes.alignCenter}
          >
            <div className="App">
              <input type="file" 
                onChange={event =>
                this.handleFieldChange('upload', event.target.files)
                } 
                id="upload" accept="image/*" />
              
            </div>
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            xl={6}
            className={classes.alignLeft}
          >
            <img className={classes.img} alt="uploadImage" src={file} />
          </Grid>
          <Grid
            item
            xs={8}
            sm={8}
            md={8}
            xl={8}
            className={classes.alignCenter}
            style={{paddingTop:"30px"}}
          >
            <TextField
              className={[classes.contentWidth, classes.labelFont]}
              label="Contenido"
              name="content"
              type="text"
              defaultValue={data.contenido}
              required
              multiline
              rows={13}
              onChange={event =>
                this.handleFieldChange('contenido', event.target.value)
              }
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            xl={4}
            className={classes.alignLeft}
          >
            <Variable/>
          </Grid>
          {isLoad?
            <Loading/>
            :
            sucess?
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              xl={12}
              className={classes.alignCenter}
            >
              <Typography className={classes.success}>Template Editado</Typography>
            </Grid>
            :
            <Grid
              container
              spacing={1}
            >
              <Grid
                item
                xs={5}
                sm={5}
                md={5}
                xl={5}
                className={classes.alignRight}
              >
                <Button onClick={this.save} className={classes.buttonSave}>Guardar</Button>
              </Grid>
              <Grid
                item
                xs={2}
                sm={2}
                md={2}
                xl={2}
                className={classes.alignCenter}
              >
              </Grid>
              <Grid
              item
              xs={5}
              sm={5}
              md={5}
              xl={5}
              className={classes.alignLeft}
            >
              
              <Button onClick={this.close.bind()} value="0" className={classes.buttonSave}>Cancelar</Button>
            </Grid>
            </Grid>
          }
        </Grid>
        
      </PortletContent>
    )
  }
}

export default withStyles(styles)(EditTemplate);
